import {
  createStyles,
  Text,
  SimpleGrid,
  Group,
  rem,
} from "@mantine/core";
import PageContainer from "./layout/PageContainer";
import {
  IconBrandWhatsapp,
  IconBrandFacebook,
  IconMail,
  IconPhone,
  IconMapPin,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  footer: {
    marginTop: 0,
    backgroundColor: "#141210",
    color: "#e8e6e2",
    padding: `${rem(56)} 0 ${rem(28)}`,
  },
  sectionTitle: {
    fontSize: theme.fontSizes.xs,
    fontWeight: 600,
    color: "rgba(255,255,255,0.6)",
    marginBottom: theme.spacing.md,
    textTransform: "uppercase",
    letterSpacing: "0.12em",
  },
  brandTagline: {
    fontSize: theme.fontSizes.sm,
    color: theme.colors.gray[3],
    maxWidth: 200,
    lineHeight: 1.6,
  },
  link: {
    color: theme.colors.gray[3],
    textDecoration: "none",
    fontSize: theme.fontSizes.sm,
    transition: "color 0.2s ease",
    display: "block",
    marginBottom: theme.spacing.xs,
    "&:hover": { color: theme.colors.orange[5] },
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing.sm,
    marginBottom: theme.spacing.md,
    color: "rgba(255,255,255,0.7)",
    fontSize: theme.fontSizes.sm,
  },
  contactLink: {
    color: "rgba(255,255,255,0.7)",
    textDecoration: "none",
    transition: "color 0.2s ease",
    "&:hover": { color: theme.colors.orange[5] },
  },
  deliveryInfo: {
    fontSize: theme.fontSizes.sm,
    color: "rgba(255,255,255,0.55)",
    lineHeight: 1.7,
  },
  bottomBar: {
    borderTop: "1px solid rgba(255,255,255,0.08)",
    marginTop: rem(32),
    paddingTop: rem(24),
    textAlign: "center",
    color: theme.colors.gray[5],
    fontSize: theme.fontSizes.sm,
  },
}));

const quickLinks = [
  { to: "/", label: "首頁" },
  { to: "/product", label: "零售及批發產品" },
  { to: "/contact", label: "查詢訂銷" },
];

export default function PageFooter() {
  const { classes } = useStyles();
  return (
    <footer className={classes.footer}>
      <PageContainer>
        <SimpleGrid
          cols={4}
          spacing="xl"
          breakpoints={[
            { maxWidth: "md", cols: 2 },
            { maxWidth: "sm", cols: 1 },
          ]}
        >
          <div>
            <Link to="/" style={{ textDecoration: "none", display: "inline-block" }}>
              <img
                src={`${process.env.PUBLIC_URL || ""}/companylogo2.png`}
                alt="猫山王朝"
                width={360}
                height={103}
                decoding="async"
                style={{ height: 56, width: "auto", objectFit: "contain", display: "block", marginBottom: 8 }}
              />
            </Link>
            <Text className={classes.brandTagline}>
              馬來西亞頂級貓山王榴槤，每週新鮮空運到港
            </Text>
          </div>

          <div>
            <Text className={classes.sectionTitle}>快速連結</Text>
            {quickLinks.map((l) => (
              <Link key={l.to} to={l.to} className={classes.link}>
                {l.label}
              </Link>
            ))}
          </div>

          <div>
            <Text className={classes.sectionTitle}>聯絡我們</Text>
            <div className={classes.contactItem}>
              <IconPhone size={18} style={{ flexShrink: 0, marginTop: 2 }} />
              <a href="tel:+85298312915" className={classes.contactLink}>
                +852 9831 2915
              </a>
            </div>
            <div className={classes.contactItem}>
              <IconBrandWhatsapp size={18} style={{ flexShrink: 0, marginTop: 2 }} />
              <span className={classes.contactLink}>WhatsApp 9831 2915</span>
            </div>
            <div className={classes.contactItem}>
              <IconMail size={18} style={{ flexShrink: 0, marginTop: 2 }} />
              <a href="mailto:hangtatmsk@gmail.com" className={classes.contactLink}>
                hangtatmsk@gmail.com
              </a>
            </div>
            <div className={classes.contactItem}>
              <IconMapPin size={18} style={{ flexShrink: 0, marginTop: 2 }} />
              <span>
                九龍青山道479至479A號
                <br />
                麗昌工廠大廈2樓202 P室
              </span>
            </div>
          </div>

          <div>
            <Text className={classes.sectionTitle}>送貨詳情</Text>
            <Text className={classes.deliveryInfo}>
              急凍產品預約送貨
              <br />
              不包括：馬灣、愉景灣、離島區、
              <br />
              上樓及停車場費用
              <br />
              傳真：8147 0126
            </Text>
            <Group spacing="sm" mt="md">
              <a
                href="https://www.facebook.com/pages/category/Food-Wholesaler/%E8%B2%93%E5%B1%B1%E7%8E%8B%E6%9C%9D-387798108690714"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.contactLink}
              >
                <IconBrandFacebook size={22} />
              </a>
            </Group>
          </div>
        </SimpleGrid>

        <div className={classes.bottomBar}>
          © {new Date().getFullYear()} 猫山王朝 Musang King Empire. All rights reserved.
        </div>
      </PageContainer>
    </footer>
  );
}
